// Unified tab styling shared across the app's three tab levels
// (survey configuration sections, Analyze sub-nav, and nested selectors such
// as the delivery channel switch). Mirrors the "Promoter Ninja UI" design:
// uppercase labels, muted → ink on select, and a blue underline indicator.

export const UNIFIED_TAB_ACTIVE = '#2E3A47';
export const UNIFIED_TAB_INACTIVE = '#9AA3AE';
export const UNIFIED_TAB_BORDER = '#E2E7EE';

// Spread onto a MUI <Tabs sx={...}>. The owning component adds its own margins.
// The underline indicator uses the theme primary color.
const unifiedTabsSx = {
  minHeight: 'auto',
  borderBottom: `1px solid ${UNIFIED_TAB_BORDER}`,
  '& .MuiTabs-indicator': {
    height: 3,
    borderRadius: '3px',
    backgroundColor: 'primary.main',
  },
  '& .MuiTab-root': {
    textTransform: 'uppercase',
    fontSize: 13,
    fontWeight: 500,
    letterSpacing: '.7px',
    color: UNIFIED_TAB_INACTIVE,
    // Stay at full opacity regardless of the Tabs `textColor` prop — MUI's
    // textColor="inherit" variant otherwise dims unselected tabs to 0.6.
    opacity: 1,
    minHeight: 'auto',
    minWidth: 'auto',
    px: 0,
    py: 0,
    pb: 2,
    mr: 4,
    transition: 'color .2s',
    '&:hover': { color: UNIFIED_TAB_ACTIVE },
    '&.Mui-selected': { color: UNIFIED_TAB_ACTIVE, fontWeight: 700 },
  },
};

export default unifiedTabsSx;
